import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=157c3279&scoped=true&"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=157c3279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c3279",
  null
  
)

export default component.exports